export default "__VITE_ASSET__Dytlkz1z__"